module.exports = function (e) {
  function t(r) {
    if (o[r]) return o[r].exports;
    var n = o[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
  }

  var o = {};
  return t.m = e, t.c = o, t.d = function (e, o, r) {
    t.o(e, o) || Object.defineProperty(e, o, {
      configurable: !1,
      enumerable: !0,
      get: r
    });
  }, t.n = function (e) {
    var o = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(o, "a", o), o;
  }, t.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, t.p = "", t(t.s = 0);
}([function (e, t, o) {
  "use strict";

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function n(e, t) {
    var o = {};

    for (var r in e) {
      t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (o[r] = e[r]);
    }

    return o;
  }

  function l(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function i(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var u = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  },
      s = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      f = o(1),
      a = r(f),
      p = o(2),
      h = r(p),
      d = function d(e) {
    return e.clientHeight < e.scrollHeight;
  },
      _ = function _(e, t) {
    return e.scrollTop + e.clientHeight >= e.scrollHeight - t;
  },
      y = function y(e) {
    return 0 === e.scrollTop;
  },
      v = function v(e) {
    return e.scrollTop = e.scrollHeight - e.clientHeight;
  },
      b = function b(e, t) {
    return t.scrollTop += e;
  };

  t.default = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        o = t.isScrolledDownThreshold,
        r = void 0 === o ? 150 : o;
    return function (t) {
      function o(e) {
        l(this, o);
        var t = i(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
        return t._isScrolledDown = !0, t._el = null, t._scrollHeight = null, t._isScrolledUp = null, t;
      }

      return c(o, t), s(o, [{
        key: "scrollDownIfNeeded",
        value: function value() {
          this._isScrolledDown && d(this._el) && v(this._el);
        }
      }, {
        key: "handleScroll",
        value: function value(e) {
          this._isScrolledDown = _(this._el, r), y(this._el) && this.props.onScrolledTop && this.props.onScrolledTop(e), this.props.onScrolled && this.props.onScrolled(e);
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          this.scrollDownIfNeeded();
        }
      }, {
        key: "componentWillUpdate",
        value: function value(e, t) {
          this._scrollHeight = this._el.scrollHeight, this._isScrolledUp = y(this._el);
        }
      }, {
        key: "componentDidUpdate",
        value: function value() {
          if (this._isScrolledUp && null !== this._scrollHeight) {
            var e = this._el.scrollHeight - this._scrollHeight;
            this._scrollHeight = null, b(e, this._el);
          } else this.scrollDownIfNeeded();
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
              o = this.props,
              r = (o.onScrolled, o.onScrolledTop, n(o, ["onScrolled", "onScrolledTop"]));
          return a.default.createElement(e, u({}, r, {
            ref: function ref(e) {
              return t._el = h.default.findDOMNode(e);
            },
            onScroll: function onScroll(e) {
              return t.handleScroll(e);
            }
          }));
        }
      }]), o;
    }(a.default.PureComponent);
  };
}, function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("react-dom");
}]);